import { Component, ComponentFactoryResolver, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PopupResponseEvents } from 'src/app/common/enums/enums';
import { MembershipPopupInputInfo, SunChartOptionPopupInputInfo } from 'src/app/common/models/PopupInputInfo';
import { PopupResponse } from 'src/app/common/models/PopupResponse';
import { OverlayService } from 'src/app/services/UI/overlay.service';
import { PopupBaseComponent } from '../../popup-base/popup-base.component';
import { DynamicPaymentOptionDirective } from '../directives/dynamic-payment-option.directive';
import { PaymentOption1Component } from '../payment-option1/payment-option1.component';
import { PaymentOption2Component } from '../payment-option2/payment-option2.component';
import { MembershipUpgradePopupService } from '../services/membership-upgrade-popup.service';
import { MembershipTemplate } from 'src/app/common/enums/membershipTemplate';
import { RootMember } from 'src/app/common/models/RootMember';

@Component({
    selector: 'app-membership-upgrade-popup',
    viewProviders: [DynamicPaymentOptionDirective],
    templateUrl: './membership-upgrade-popup.component.html',
    styleUrls: ['./membership-upgrade-popup.component.scss'],
    standalone: false
})
export class MembershipUpgradePopupComponent extends PopupBaseComponent implements OnInit, OnDestroy {
  //select ng-template from this directive
  // @ViewChild(DynamicPaymentOptionDirective, { static: true })
  // dynamicPaymentOptiontView: DynamicPaymentOptionDirective;

  // options = {
  //   Demo: PaymentOption1Component,
  //   Basic: PaymentOption2Component,

  // };

  option: string;
  Demo = false;
  isSaveEnable: boolean;
  membershipServiceSubscription: any;
  titleOption: string;
  selectedGenaration: number;
  reportTitle: string;
  membershipTemplate: string;
  rootMember: RootMember;
  MembershipTemplate: typeof MembershipTemplate;
  // private _componentFactoryResolver: ComponentFactoryResolver;
  // private _dynamicPaymentOptiontView: DynamicPaymentOptionDirective;


  constructor(private membershipservice: MembershipUpgradePopupService, overlayService: OverlayService, componentFactoryResolver: ComponentFactoryResolver,
    dynamicPaymentOptiontView: DynamicPaymentOptionDirective) {
    super(membershipservice, overlayService)
    // this._componentFactoryResolver = componentFactoryResolver;
    // this._dynamicPaymentOptiontView = dynamicPaymentOptiontView;
  }

  ngOnInit(): void {
    this.show();
    this.display();
  }


  /**
     * Display membership upgrade popup
     */
  display() {
    this.isSaveEnable = false;
    this.membershipServiceSubscription = this.membershipservice.onVisibilityChanged().subscribe((data: MembershipPopupInputInfo) => {
      this.popupWidth = data.popWidth;
      this.titleOption = data.TitleOption;
      this.rootMember = data.rootMember;
      this.membershipTemplate = data.memberShipUpgradeTemplate;
    })
  }


  /**
      * when cancelling the popup, redirect to dashbord
      */
  cancel() {
    this.membershipservice.goToHomePage(this.rootMember);
    this.isSaveEnable = false;
    let popupResponse = new PopupResponse();
    popupResponse.Status = PopupResponseEvents.Cancelled;
    this.membershipservice.setSelection(popupResponse);
    this.membershipservice.changeVisibility(false, null);

  }


  // loadReport() {
  //   const reportComponent = this.options[this.option];
  //   console.log("ddddddddddd" + this.option)
  //   console.log("lhhhhhhhhhhhhhoad template" + this.options )
  //   console.log(this.options)
  //   console.log("load template" + reportComponent)

  //   const factory = this._componentFactoryResolver.resolveComponentFactory(
  //     reportComponent
  //   );

  //   const viewContainerRef = this._dynamicPaymentOptiontView.viewContainerRef;

  //   // clear any existing components in the view container
  //   viewContainerRef.clear();

  //   // create and return the component
  //   this._dynamicReportRef = viewContainerRef.createComponent(factory);
  //   console.log("load template")
  // }


  ngOnDestroy() {
    this.membershipServiceSubscription.unsubscribe();
  }

}

